import { css } from "styled-components";
export const riotProductSkin = (chroma) => css `
  & {
    justify-content: flex-start;
    column-gap: 24px;
    row-gap: 12px;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 32px;
    ${chroma.mediaQueries.mobileDown} {
      margin-bottom: 24px;
    }

    img,
    svg {
      margin-right: 24px;
      ${chroma.mediaQueries.mobileDown} {
        margin-right: 0;
        height: 22px;
        width: auto;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map